import React from "react"

import { useIntl } from "react-intl"

const Footer = () => {
  const intl = useIntl()
  return (
    <footer className="text-center">
      <div>
        <a
          href="https://belgacoin.zendesk.com/hc/en-us/articles/115001335771"
          target="_blank"
          className="mr-2"
        >
          {intl.formatMessage({ id: "Contact" })}
        </a>
        <a href="/policies_terms" className="mr-2">
          {intl.formatMessage({ id: "Terms and Conditions" })}
        </a>
        <a href="/policies_privacy" className="mr-2">
          {intl.formatMessage({ id: "Privacy Policy" })}
        </a>
        <a href="/policies_aml" className="mr-2">
          {intl.formatMessage({ id: "AML Policy" })}
        </a>
        <a href="/policies_cookies" className="mr-2">
          {intl.formatMessage({ id: "Cookie Policy" })}
        </a>
        <a href="/policies_us" className="mr-2">
          {intl.formatMessage({ id: "US Policy" })}
        </a>
        {intl.formatMessage({ id: "Business/VAT Number BE0560665542" })}
      </div>
      <div>
        © {new Date().getFullYear()} Belgacoin.com. All rights reserved.
      </div>
    </footer>
  )
}

export default Footer
